import ReactHtmlParser from 'react-html-parser'

/**
 * A video URL to be shown as a still frame, nudged a second in.
 *
 * Facebook's own thumbnail is the still we want, but it does not exist until the
 * transcode finishes — minutes after an upload — so surfaces that need a picture
 * now fall back to a muted `<video>` pointed at our stored copy. Left at zero
 * that shows the opening frame, and produced video routinely opens on black (a
 * fade-up, a slate), which reads as a broken thumbnail rather than a dark ad.
 *
 * A media fragment rather than a seek: it is applied before first paint, needs
 * no element wiring, and is never sent to the server, so appending it to a
 * signed URL cannot invalidate the signature. A browser that ignores it shows
 * frame zero, which is the behaviour this replaces.
 */
export const videoStillURL = (url: string): string => `${url}#t=1`

export function getIFrameSource(html: string): string {
  const iframe = ReactHtmlParser(html).find(node => node?.type === 'iframe')
  return iframe?.props.src ?? ''
}
